import { ViewChildren, ViewContainerRef, QueryList, EventEmitter, ViewChild, ElementRef, ComponentFactoryResolver, ChangeDetectorRef, AfterContentInit, Directive } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { IButtonAction, IDetailComponent } from "../components/mf-blade/mf-blade.component";
import { Subscription } from "rxjs";
import { IBladeForm } from "../components/mf-blade-forms/mf-blade-forms.component";
import { SplitAreaDirective } from "angular-split";
import { IdentityAuthService } from "../../services/identity-auth/identity-auth.service";
import { Router, ActivatedRoute } from "@angular/router";
import { BreadCrumbsService } from "../../services/bread-crumbs/bread-crumbs.service";
import { ApiService } from '@services/api/api.service';
import { FormRouteController } from "./FormRouteController";
import { NestedNavigationService } from "../../services/nested-navigation/nested-navigation.service";
import { ToastrService } from 'ngx-toastr';
import { ListPageComponent } from "../components/mf-list-page/mf-list-page.component";
import { MfGeneratedFormComponent } from "../components/mf-generated-form/mf-generated-form.component";
import { IEntityOptions, IFormOptions, IActionOptions, ICustomActionOptions } from "../interfaces/IEntity";
import { ActionType } from "../core/Enums";
import { ToolbarActionsService, ToolbarActionType } from "../../services/toolbar-actions/toolbar-actions.service";
import { MatDialog } from "@angular/material/dialog";
import { MfControlPopupComponent } from "../components/mf-control-popup/mf-control-popup.component";
import { MfControlUnsavedPopupComponent } from "../components/mf-control-unsaved-popup/mf-control-unsaved-popup.component";
import { AutoPanelNavComponent } from '../components/auto-panel-nav/auto-panel-nav.component';
@Directive()
export class FormController {
  @ViewChildren('components', { read: ViewContainerRef }) detailComponentTargets: QueryList<ViewContainerRef>;
  //@ViewChild('actionOverlay', { static: true }) actionOverlay: OverlayPanel;
  @ViewChildren('bladeScroll', { read: ViewContainerRef }) bladeScroll: any;
  private _menuItems: Array<any>;
  private componentInstance: any = new Array();
  private _headerIdentifier: any;
  private _selectedMenuItemIndex: any = 0;
  public customEntityId: any;
  private _forms: Array<IFormOptions>;
  protected getPanelHeaderFunc: any;
  protected _hideSideMenu: boolean = false;
  public dialogRef: any;
  public entityName: any;
  public refreshListByEntityName: any;
  public formOnly: boolean;
  public isDialog: boolean = false;
  public get authService() {
    return this.auth;
  }
  public get components(): Array<IDetailComponent> {
    if (this.detailComponents)
      return this.detailComponents;
  };
  public get header(): string { return this.displayName }
  public set header(val) {
    this.displayName = val;
    if (val) {
      var breadCrumb = this.breadCrumbService.breadcrumbs.filter(o => { return o.id == this.formIndex });
      if (breadCrumb.length > 0)
        breadCrumb[0].header = val;
    }
  }
  public get headerIdentifier() {
    return this._headerIdentifier;
  }
  public set headerIdentifier(val) {
    this._headerIdentifier = val;
    if (val) {
      var breadCrumb = this.breadCrumbService.breadcrumbs.filter(o => { return o.id == this.formIndex });
      if (breadCrumb.length > 0)
        breadCrumb[0].label = val;
    }
  }
  public get selectedMenuItemIndex() {
    return this._selectedMenuItemIndex;
  }
  public set selectedMenuItemIndex(val) {
    var _th = this;
    var newVal = val;
    //console.log(val);
    if (this.componentInstance[this._selectedMenuItemIndex]) {
      if (this.componentInstance[this._selectedMenuItemIndex].component.unsavedChanges) {
        let dialogRef = this.dialogService.open(MfControlUnsavedPopupComponent, {
          data: {
            title: 'Unsaved changes', icon: ['fal', 'exclamation-triangle'], iconColor: "orange", message: "You have unsaved changes on this form which may be lost if not saved", actions: [{ display: 'Save Changes', color: "primary" }, { display: 'Discard Changes', color: 'warn' }]
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result.display == "Save Changes")
            _th.componentInstance[_th._selectedMenuItemIndex].component.save(false, newVal);
          else if (result.display == "Discard Changes") {
            _th.messageService.warning("Changes have not been saved and were discarded", "Changes discarded");
            _th.componentInstance[_th._selectedMenuItemIndex].component.loadEntity(true);
            _th.selectedMenuItemIndexChange(newVal);
          }
          else {
            _th.messageService.warning("Changes have not been saved", "Navigation cancelled");
          }
        });

        return;
      }
    }

    setTimeout(() => {
      this.selectedMenuItemIndexChange(val);
    },1)

  }
  public selectedMenuItemIndexChange(val) {
    this._selectedMenuItemIndex = val;
    if (!this.componentInstance[val])
      return;
    if (!this.componentInstance[val].component.buttonActions)
      this.buttonActions = new Array();
    else this.buttonActions = this.componentInstance[val].component.buttonActions;
    if (this.parent.CurrentIndex == this.formIndex) {
      if (!this.hideSideMenu && this.nestedNavigationService.actions)
        this.nestedNavigationService.actions.forEach(o => {
          if (o.value == this.selectedMenuItemIndex && o.isComponentNav)
            o.active = true;
          else o.active = false;
        });
    }

    if (this.componentInstance[val].component.resize)
      this.componentInstance[val].component.resize();

    var scrollBlade = this.bladeScroll.toArray()[val];
    if (scrollBlade) {
      setTimeout(_ => {
        if (scrollBlade.nativeElement)
          scrollBlade.nativeElement.scrollTop = 0;
      }, 1)
    }
    this.toolbarActionService.selectedNestedFormId = val;
  }
  public get onBladeSave() { return this.onSaveEvent }
  public get getPanelSubHeader() {
    if (this.getPanelHeaderFunc) {
      var header = this.getPanelHeaderFunc(this);
      if (header && header != '')
        return ' - ' + header;
    }
    return this.headerIdentifier ? ' - ' + this.headerIdentifier : '';
  }
  public get getPanelSubTitle() {
    if (this.getPanelSubtitleFunc) {
      var subtitle = this.getPanelSubtitleFunc(this);
      if (subtitle && subtitle != '')
        return subtitle;
    }
    return this.subtitle;
  }
  public get previousEntityId() {
    this.parent.currentRouteParams
    let maxIndex = 0;
    Object.keys(this.parent.currentRouteParams).forEach(key => {
      if (key.indexOf("id_") != -1) {
        let idIndex = parseInt(key.substring(3, key.length));
        if (idIndex > maxIndex && idIndex < this.formIndex)
          maxIndex = idIndex;
      }
    });
    return this.parent.currentRouteParams["id_" + maxIndex];
  }
  public get selectedActionMenuItemIndex() {
    return null//: any;
  }
  public get menuItems() {
    return this._menuItems;
  }
  public set menuItems(val) {
    this._menuItems = val;
  }
  public get entityId() {
    return this._entityId;
  }
  public set entityId(val) {
    if (this._entityId != val)
      this.selectedMenuItemIndex = 0;
    this._entityId = val;
    //if (val != null)
    this.entityIdChange.emit(val);
  }
  public get hideSideMenu() { return this._hideSideMenu; }
  public set hideSideMenu(value) { this._hideSideMenu = value; }
  public set bladeSetup(val) {
    this.onSaveEvent = val.onSaveEvent;
    this.onMenuActionOverlayClick = val.onMenuActionOverlayClick;
    this.getPanelSubtitleFunc = val.getPanelSubtitleFunc;
    this.menuActions = val.menuActions;
    this.onFormLoad = val.onFormLoad;
  }
  public buttonActions: Array<IButtonAction> = new Array();
  public menuActions: Array<IDetailComponent>;
  public menuActionItems: Array<IDetailComponent>;
  public _entityId: any;
  public showActionDialog: boolean;
  public overlayIsSmallText: boolean;
  public panelHeader: string;
  public subtitle: string;
  public overlayPanelData: any = {};
  public overlayPanelIdentifier: any;
  public minimised: boolean;
  public loading: boolean;
  public entityOptions: IEntityOptions;
  public formOptions: IFormOptions; public gridOptions: IFormOptions;
  public entityIdChange = new EventEmitter();
  public detailComponents: Array<IDetailComponent>;
  public getPanelSubtitleFunc: any;
  public formIndex: any;
  public displayName: any;
  public parent: FormRouteController;
  public hideClose: boolean;
  public loadOnlyOnEntity: boolean;

  constructor(public apiService?: ApiService, private route?: ActivatedRoute, private componentFactoryResolver?: ComponentFactoryResolver,
    public messageService?: ToastrService, public confirmationService?: ConfirmationService, public dialogService?: MatDialog,
    public auth?: IdentityAuthService,
    public nestedNavigationService?: NestedNavigationService,
    public breadCrumbService?: BreadCrumbsService,
    public cdr?: ChangeDetectorRef,
    public toolbarActionService?: ToolbarActionsService
  ) {
  }

  private async buildComponents(componentIndex?) {
    for (let i = 0; i < this.components.length; i++) {
      if (componentIndex == i) {

      }
      if (typeof componentIndex != 'undefined' && componentIndex != i) {

      }

      else {
        let component: IDetailComponent = this.components[i];
        if (component) {
          let target = this.detailComponentTargets.toArray()[i];
          if (!component.component) {
            if (component.formOptions) {
              component.component = MfGeneratedFormComponent;
            }
            else if (component.gridOptions) {
              component.component = ListPageComponent;

              if (component.gridOptions.panelIndexToNavigateFromList)
                component.bladeIndexToNavigateTo = component.gridOptions.panelIndexToNavigateFromList
            }
            else if (component.entityOptions && component.entityOptions.grid && !this.formOnly) {
              component.component = ListPageComponent;

              if (component.entityOptions.grid.panelIndexToNavigateFromList)
                component.bladeIndexToNavigateTo = component.entityOptions.grid.panelIndexToNavigateFromList
            }
            else if (component.entityOptions || component.formOptions)
              component.component = MfGeneratedFormComponent;
            else {
              component.component = AutoPanelNavComponent;
              this.hideClose = true;
            }
            if (component.entityOptions && component.entityOptions.loadPrepareFields) {
              this.loading = true;
              await component.entityOptions.loadPrepareFields(this, component.entityOptions);
              this.load();
              component.entityOptions.loadPrepareFields = null;
              this.loading = false;
              setTimeout(() => {
                this.buildComponents(componentIndex);
              }, 0);
              return;

            }
          }
          else {

          }
          let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component.component);
          let componentRef: any = target.createComponent(widgetComponent);
          let _component: any = (componentRef.instance);
          _component.parent = this;
          _component.listIndex = i;
          _component.menuHidden = component.menuHidden;
          _component.entityOptions = component.entityOptions;
          _component.dialogRef = this.dialogRef;

          if (this.loadOnlyOnEntity) _component.listLoadOnlyOnEntityId = true

          if (this.customEntityId) { 

            _component.instanceEntityId = this.customEntityId;
          }
          if ( component.customEntityId) {

            _component.instanceEntityId = component.customEntityId;
          }
          if (this.isDialog)
            _component.isDialog = this.isDialog



          this.componentInstance.push({ componentDetail: component, component: _component });
          if (_component.load && component.entityOptions)
            _component.load();
        }

      }
    }
    //if (!this.selectedMenuItemIndex)
    //  this.selectedMenuItemIndex = 0;
    var _th = this;
    if (typeof componentIndex != 'undefined') {

    } else {
      if (!_th.hideClose)
        _th.toolbarActionService.addItem({ formId: _th.formIndex, command: function () { _th.closeBlade() }, icon: "close", type: ToolbarActionType.IconButton, label: "Close", identifier: "close", sortOrder: 200 })
      _th.toolbarActionService.addItem({ dropdownGroup: 'Advanced', label: 'Reload', formId: _th.formIndex, command: function () { _th.reload() }, icon: "refresh", type: ToolbarActionType.IconButton, identifier: "refresh", sortOrder: 199 })
    }
  }

  private buildTabsFromActions(action: IActionOptions, groupName?: string, groupExpanded?: boolean) {
    let self = this;
    if (action.permissions) {
      if (!self.auth.hasAnyPermissionsArr(action.permissions))
        return;
    }
    let displayName: string = action.displayName;
    if (!displayName && action.tab && action.tab.displayName) displayName = action.tab.displayName;
    if (!displayName && action.tab && action.tab.model && action.tab.model.displayName) displayName = action.tab.model.displayName;
    if (displayName && displayName.split("|").length > 1) displayName = displayName.split("|")[1];
    self.detailComponents.push({
      index: self.detailComponents.length,
      displayName: displayName,
      entityOptions: action.tab.entity,
      gridOptions: action.tab.grid,
      formOptions: action.tab.form,
      customEntityId: action.tab.customEntityId
    });
    let index = self.detailComponents.length - 1

    self.menuItems.push({
      entityName: action.tab.entity.name,
      label: displayName,
      value: index,
      iconUrl: action.iconUrl ? action.iconUrl : null,
      icon: action.icon ? action.icon : (action.iconUrl ? null : 'clipboard'),
      menuItems: self.menuItems,
      command: function () {
        self.selectedMenuItemIndex = index;
      },
      groupName: groupName,
      expanded: groupExpanded,
      get hide(): boolean {
        if (typeof action.show != undefined && self.componentInstance[0]) {
          if (action.show instanceof Function)
            return !action.show(self, self.componentInstance[0].component.entityData);
          else !action.show
        }
      },
      active: self.selectedMenuItemIndex == index,
      isComponentNav: true,
      sortOrder: typeof action.sortOrder != 'undefined' ? action.sortOrder : self.menuItems.length,
      permissions: action.tab.permissions
    })
  }
  public clearActionsWithEntity(entity) {
    var self = this;
    var toRemove = self.detailComponents.filter(o => o.entityOptions.name == entity.name);
    toRemove.forEach(o => {
      self.detailComponents.splice(self.detailComponents.indexOf(o), 1)
    });

    var toRemoveMenu = self.menuItems.filter(o => o.entityName == entity.name);
    toRemoveMenu.forEach(o => {
      var index = self.menuItems.indexOf(o);
      self.toolbarActionService.removeItemByIndex(this.formIndex, index);
    });

    var toRemoveMenu = self.menuItems.filter(o => o.entityName == entity.name);
    toRemoveMenu.forEach(o => {
      var index = self.menuItems.indexOf(o);
      self.menuItems.splice(index, 1);
    });



  }
  public addAction(c) {
    var self = this;
    var before = self.detailComponents.length - 1;
    if (c.custom) {
      c.custom.actions.forEach(ca => {
        if (ca.tab) self.buildTabsFromActions(ca, c.custom.groupName, c.custom.expanded);
        else if (!ca.formButton) {
          let index: number = self.menuItems.length;
          self.menuItems.push({
            label: ca.displayName,
            value: index,
            iconUrl: ca.iconUrl,
            icon: ca.icon ? ca.icon : (ca.iconUrl ? null : 'bookmark'),
            isButton: ca.isButton,
            isBottomButton: ca.isBottomButton,
            command: function () {
              let idx: number = index;
              if (ca.action) idx = ca.action(self.componentInstance[0].component, self.menuItems[index]);
              else self.selectedMenuItemIndex = idx != undefined && idx != null ? idx : index;
            },
            groupName: c.custom.groupName,
            expanded: c.custom.expanded,
            get hide(): boolean {
              if (typeof ca.show != undefined && self.componentInstance[0]) {
                if (ca.show instanceof Function)
                  return !ca.show(self, self.componentInstance[0].component.entityData);
                else !ca.show
              }
            },
            active: self.selectedMenuItemIndex == index,
            isComponentNav: !ca.action,
            sortOrder: typeof ca.sortOrder != 'undefined' ? ca.sortOrder : self.menuItems.length,
            permissions: ca.permissions
          })
        }
      })
    }
    else if (c.tab) {
      self.buildTabsFromActions(c, null, c.custom ? c.custom.expanded : null);
    }

    setTimeout(() => {
      var after = self.detailComponents.length - 1;
      while (before <= after) {
        self.buildComponents(++before);
      }
    }, 0);

  }

  public load() {
    let self = this;
    if (self.entityOptions) {
      let actions = new Array<IActionOptions>();
      self._forms = self.entityOptions.forms;
      if (!self._forms && self.entityOptions.form) {
        self._forms = new Array<IFormOptions>();
        self._forms.push(self.entityOptions.form);
      }

      self.detailComponents = new Array();
      self.detailComponents.push({ index: 0, displayName: "", isMenuHidden: false, entityOptions: self.entityOptions, formOptions: self.formOptions, gridOptions: self.gridOptions });
      self._menuItems = new Array();
      if (!self.entityOptions.grid || self.formOnly) self.menuItems.push({
        label: self.entityOptions.form.detailsDisplayName ? self.entityOptions.form.detailsDisplayName : "Details",
        value: 0,
        icon: 'clipboard',
        command: function () {
          self.selectedMenuItemIndex = 0
        },
        active: self.selectedMenuItemIndex == 0,
        isComponentNav: true,
        sortOrder: self.menuItems.length,
        permissions: null
      })

      var isList = false;
      if (((self.entityOptions && self.entityOptions.grid) || self.gridOptions) && !this.formOnly)
        isList = true;

      if (!isList) { self._forms.forEach(form => { if (form.actions) form.actions.forEach(z => { actions.push(z); }) }) }
      if (isList && self.entityOptions.grid && self.entityOptions.grid.actions) { self.entityOptions.grid.actions.forEach(z => { actions.push(z); }) }
      actions.forEach(c => {
        if (c.custom) {
          c.custom.actions.forEach(ca => {
            if (ca.tab) self.buildTabsFromActions(ca, c.custom.groupName, c.custom.expanded);

            else if (!ca.formButton) {
              let index: number = self.menuItems.length;
              self.menuItems.push({
                label: ca.displayName,
                value: index,
                iconUrl: ca.iconUrl,
                icon: ca.icon ? ca.icon : (ca.iconUrl ? null : 'bookmark'),
                isButton: ca.isButton,
                isBottomButton: ca.isBottomButton,
                command: function () {
                  let idx: number = index;
                  if (ca.action) idx = ca.action(self.componentInstance[0].component, self.menuItems[index]);
                  else self.selectedMenuItemIndex = idx != undefined && idx != null ? idx : index;
                },
                groupName: c.custom.groupName,
                expanded: c.custom.expanded,
                get hide(): boolean {
                  if (typeof ca.show != undefined && self.componentInstance[0]) {
                    if (ca.show instanceof Function)
                      return !ca.show(self, self.componentInstance[0].component.entityData);
                    else !ca.show
                  }
                },
                active: self.selectedMenuItemIndex == index,
                isComponentNav: !ca.action,
                sortOrder: typeof ca.sortOrder != 'undefined' ? ca.sortOrder : this.menuItems.length,
                permissions: ca.permissions
              })
            }
          })
        }
        else if (c.tab) {
          self.buildTabsFromActions(c, null, c.custom ? c.custom.expanded : null);
        }
        //else {
        //   else  this.menuItems.push({
        //      label: c.displayName, value: this.menuItems.length, icon: 'dashboard'
        //    })
        //}

      })
    }
    else {
      self.detailComponents = new Array();
      self.detailComponents.push({ index: 0, displayName: "", isMenuHidden: false });
    }
  }
  public reload() {
    this.componentInstance.forEach(o => { if (o.component.loadEntity) o.component.loadEntity(true); })
  }
  public reloadDetailComponent(index: number) {
    var component = this.componentInstance[index].component;
    if (component.loadEntity) component.loadEntity();
  }
  public buildMenus(entityData, newItem, listIndex?, context?) {
    if (this.toolbarActionService.selectedFormId == this.formIndex && this.toolbarActionService.selectedNestedFormId == this.selectedMenuItemIndex) {
      var hideSideMenu = false;
      if (this.gridOptions && this.gridOptions.hideSideMenu) hideSideMenu = true;
      if (this.formOptions && this.formOptions.hideSideMenu) hideSideMenu = true;
      if (this.formOnly && this.entityOptions && this.entityOptions.form.hideSideMenu)
        this.hideSideMenu = true;
      this.nestedNavigationService.setActions(this.hideSideMenu || hideSideMenu ? new Array() : this.menuItems, this.toolbarActionService.route, this.toolbarActionService.selectedFormId, this.toolbarActionService.selectedNestedFormId);
    }
  }
  public refreshMenus() {
    if (this.toolbarActionService.selectedFormId == this.formIndex && this.toolbarActionService.selectedNestedFormId == this.selectedMenuItemIndex)
      this.nestedNavigationService.setActions(this.menuItems, this.toolbarActionService.route, this.formIndex, this.selectedMenuItemIndex);
  }
  public setButtonActions() {
    if (!this.componentInstance[this.selectedMenuItemIndex].component.buttonActions) this.buttonActions = new Array();
    else this.buttonActions = this.componentInstance[this.selectedMenuItemIndex].component.buttonActions;
  }
  public minimise() {
    if (this.minimised) return;
    this.minimised = true;
    this.componentInstance.forEach(o => { o.isHidden = true; })
  }
  public expandForm() {
    if (!this.minimised) return;
    this.minimised = false;
    this.componentInstance.forEach(o => { o.isHidden = false; })
  }
  public navigateToIndex(index, id, startNavIndex?, extraParams?) {
    this.parent.navigateToIndex(index, id, startNavIndex, extraParams);
  }
  public closeBlade() {
    if (this.parent.navigateBackToIndex) this.parent.navigateBackToIndex(this.formIndex);
  }
  public getFormInstanceByIndex(index: number) {
    var form = this.componentInstance[index];
    if (form && form.component) return form.component;
    else return;
  }
  public reloadFormByIndex(index: number) {
    var component = this.componentInstance[index].component;
    if (component.loadEntity) component.loadEntity(true);
  }
  public menuActionOverlayClick() {
    this.onMenuActionOverlayClick(this);
  }

  public ngOnInit() {
    //console.log('ngOnInit')
    this.routeChanged();
    if (this.parent && this.parent.currentRouteParamsChange)
      this.parent.currentRouteParamsChange.subscribe(routeParams => { this.routeChanged(); });



    //this.auth.userProfileObserver.subscribe(o => {
    //  this.reload();
    //  this.components.forEach(comp => {
    //    if (comp.isMenuHidden instanceof Function) {
    //      var result = comp.isMenuHidden(comp.context, this.entityId, this.entityId == "00000000-0000-0000-0000-000000000000", comp.listIndex, comp.entityData);
    //      if (typeof result != 'undefined') {
    //        comp.menuHidden = result;
    //        var formInstance = this.getFormInstanceByIndex(comp.index);
    //        if (comp.getDataEvenIfIsMenuHidden)
    //          result = true;
    //        if (formInstance)
    //          this.getFormInstanceByIndex(comp.index).menuHidden = result;
    //      }
    //    }
    //    else {
    //      comp.menuHidden = comp.isMenuHidden;
    //      var formInstance = this.getFormInstanceByIndex(comp.index);
    //      if (formInstance) this.getFormInstanceByIndex(comp.index).menuHidden = false;
    //    }
    //  })
    //})
  }
  public ngAfterViewInit() {
    //console.log('ngAfterViewInit')
    if (this.components && this.components.length > 0) {
      this.buildComponents();
      if (typeof this.formIndex != "undefined") // ignore popups
        this.selectedMenuItemIndex = 0;
    }

  }
  public onSaveEvent = function (prop) {
  };
  public onFormLoad = function (data, formIndex, context) {
  };
  public onMenuActionOverlayClick = function (context) { };
  public menuActionItemSelected(evt) {
    if (evt.click) evt.click();
  }
  routeChanged() {
    
      

    if (this.parent && this.parent.currentRouteParams && this.parent.currentRouteParams.hasOwnProperty("id_" + this.formIndex)) {
      if (this.entityId != this.parent.currentRouteParams["id_" + this.formIndex])
        this.entityId = this.parent.currentRouteParams["id_" + this.formIndex];

      
    }
    else {
      this.entityId = null;
    }
    if (this.menuActionItems && this.menuActionItems.length <= this.selectedMenuItemIndex) {
      this.selectedMenuItemIndex = 0;
    }
    if (this.parent && this.parent.currentRouteParams && this.parent.currentRouteParams.hasOwnProperty("_" + this.formIndex + "_selectedEntity")) {
      setTimeout(() => {
        var filt = this.menuItems.filter(o => o.entityName == this.parent.currentRouteParams["_" + this.formIndex + "_selectedEntity"]);
        if (filt.length > 0)
          this.selectedMenuItemIndex = this.menuItems.indexOf(filt[0]);
      },1)
    }
    this.buildMenus(null, this.entityId == "00000000-0000-0000-0000-000000000000")
  }
  ngOnDestroy(): void { }
  public refreshForms(entityName, entityId) {
    var filteredEntities = this.componentInstance.filter(o => {
      return (o.component.entityOptions && o.component.entityOptions.name == entityName && o.component instanceof MfGeneratedFormComponent)
    });
    filteredEntities.forEach(o => {
      o.component.loadEntity(true, entityId);
    })
  }
  public refreshLists(entityName, entityId) {
    if (this.entityName == entityName || ((this.entityOptions && this.entityOptions.name == entityName) && this.refreshListByEntityName)) {
      this.load();
    }
    var filteredEntities = this.componentInstance.filter(o => {
      return (o.component.entityOptions && o.component.entityOptions.name == entityName && o.component instanceof ListPageComponent)
    });
    filteredEntities.forEach(o => {
      o.component.loadEntity(true, entityId);
    })
  }
  public setSelectedListItems(entityName, entityId) {
    var _th = this;
    if (!this.componentInstance || this.componentInstance.length == 0) {
      setTimeout(function () {
        _th.setSelectedListItems(entityName, entityId)
      }, 1)
    }
    var filteredEntities = this.componentInstance.filter(o => {
      return o.component.entityOptions && o.component.entityOptions.name == entityName;
    });
    filteredEntities.forEach(o => {
      if (o.component instanceof ListPageComponent && (!o.component.selectedItem || o.component.selectedItem.id != entityId))
        o.component._selectedItem = { id: entityId };
    })
  }
  public getBladeByIndex(index: number) {
    return this.parent.getBladeByIndex(index);
  }

  public refreshRelatedLists(entityName, entityId) {
    if (this.parent?.refreshRelatedLists)
    this.parent.refreshRelatedLists(entityName, entityId)
  }
  public refreshRelatedForms(entityName, entityId) {
    if (this.parent?.refreshRelatedForms)
      this.parent.refreshRelatedForms(entityName, entityId)
  }

  public selectedListItem: any;
}
